import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'periodoFecha',
  standalone: false
})
export class PeriodoFechaPipe implements PipeTransform {

  transform(periodo: string | number | null | undefined): string {
    if (!periodo) return '';

    const periodoStr = periodo.toString().trim();

    if (!/^\d{6}$/.test(periodoStr)) {
      return periodoStr;
    }

    const anio = parseInt(periodoStr.substring(0, 4), 10);
    const mes = parseInt(periodoStr.substring(4, 6), 10);

    const fecha = new Date(anio, mes - 1, 1);

    const opciones: Intl.DateTimeFormatOptions = { month: 'long', year: 'numeric' };
    let resultado = new Intl.DateTimeFormat('es-ES', opciones).format(fecha);

    // =======================================================================
    // ELIMINAR EL "DE": Reemplazamos ' de ' por un espacio en blanco
    // =======================================================================
    resultado = resultado.replace(' de ', ' ');

    // Capitalizamos la primera letra (ej: "Junio 2026")
    return resultado.charAt(0).toUpperCase() + resultado.slice(1);
  }

}